import Plyr from 'plyr'
import reframe from 'reframe.js'
import 'lazysizes'
import AOS from 'aos'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import DrawSvgPlugin from './vendor/DrawSVGPlugin.js'

import initInfographic from './modules/infographic.js'
import initPartnersSlider from './modules/partners-slider.js'
import initColumnSlider from './modules/column-slider.js'
import initHeader from './modules/header.js'
import initQuote from './modules/quote.js'
import initHero from './modules/hero.js'
import initScrollDraw from './modules/scroll-drawing.js'
import '../../node_modules/lazysizes/plugins/respimg/ls.respimg'
import './modules/scroll-top.js'
import './modules/toggle-password.js'
import './cookieBanner.js'
import autoSliderInit from './modules/auto-slider.js'

initInfographic()
initPartnersSlider()
initColumnSlider()
initHeader()
initQuote()
initScrollDraw()
initHero()
autoSliderInit()

// Init Plyr instances
Array.from(document.querySelectorAll('.js-video-player')).map(
    (p) => new Plyr(p)
)

AOS.init({
    useClassNames: true,
})

reframe('iframe')

gsap.registerPlugin(DrawSvgPlugin)
gsap.registerPlugin(ScrollTrigger)

Array.from(document.querySelectorAll('.animated-svg')).forEach((animatedSvg) => {
    gsap.fromTo(animatedSvg.querySelector('path'), {
        drawSVG: '0%',
    },
    {
        drawSVG: '100%',
        duration: 2,
        ease: 'none',
        scrollTrigger: {
            trigger: animatedSvg,
            start: 'top bottom+=100',
        },
    })
})
